"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMatchMedia = void 0;
// Based on https://www.js-howto.com/test-responsive-design-using-jest-and-react-testing-library/
const createMatchMedia = width => query => {
  let matches = true;
  const minWidthQuery = 'min-width: ';
  const minWidthPosition = query.indexOf(minWidthQuery);
  if (minWidthPosition > 0) {
    const minWidth = Number(query.substring(minWidthPosition + minWidthQuery.length, query.indexOf('px', minWidthPosition)));
    if (minWidth > width) {
      matches = false;
    }
  }
  const maxWidthQuery = 'max-width: ';
  const maxWidthPosition = query.indexOf(maxWidthQuery);
  if (maxWidthPosition > 0) {
    const maxWidth = Number(query.substring(maxWidthPosition + maxWidthQuery.length, query.indexOf('px', maxWidthPosition)));
    if (maxWidth < width) {
      matches = false;
    }
  }
  return {
    matches,
    media: '',
    addListener: () => null,
    removeListener: () => null,
    onchange: () => null,
    addEventListener: () => null,
    removeEventListener: () => null,
    dispatchEvent: () => true
  };
};
exports.createMatchMedia = createMatchMedia;